import moment from "moment";
import { CreditAddressAttributes, Tradeline } from "types";

export const convertToReadableAddress = (
  address: CreditAddressAttributes,
): string => {
  // key order for the main part of the address
  const mainAddressKeys: (keyof CreditAddressAttributes)[] = [
    "houseNumber",
    "direction",
    "streetName",
    "streetType",
    "unit",
    "city",
  ];

  // Keys for the state and postal code part of the address
  const secondaryAddressKeys: (keyof CreditAddressAttributes)[] = [
    "stateCode",
    "postalCode",
  ];

  const formatAddressPart = (keys: (keyof CreditAddressAttributes)[]) =>
    keys
      .map((key) => address[key])
      .filter(Boolean)
      .join(" ");

  // Combine both parts of the address
  return `${formatAddressPart(mainAddressKeys)}, ${formatAddressPart(
    secondaryAddressKeys,
  )}`;
};

const getAccountTerms = (account: Tradeline) => {
  const terms = {
    M: "Monthly",
    B: "Bi-weekly",
    W: "Weekly",
    SM: "Semi-monthly",
    Q: "Quarterly",
    A: "Annually",
    SA: "Semi-annually",
  };
  const grantedTrade = account.GrantedTrade[0];
  const paymentFrequency = grantedTrade?.PaymentFrequency[0]?.$
    .symbol as keyof typeof terms;
  if (!grantedTrade || !paymentFrequency || !terms[paymentFrequency]) {
    return "";
  }
  return terms[paymentFrequency];
};

export const getAccountDetails = (account: Tradeline) => {
  return [
    // {
    //   title: "Address",
    //   value: address,
    // },
    // {
    //   title: "Phone",
    //   value: "N/A",
    // },
    {
      title: "Date Opened",
      value: account.$.dateOpened
        ? moment(account.$.dateOpened).format("MM/DD/YYYY")
        : "N/A",
    },
    {
      title: "Responsibility",
      value: account.AccountDesignator?.at(0)?.$.description || "N/A",
    },
    {
      title: "Account Type",
      value:
        account.GrantedTrade?.at(0)?.CreditType?.at(0)?.$.description || "N/A",
    },
    {
      title: "Loan Type",
      value:
        account.GrantedTrade?.at(0)?.AccountType?.at(0)?.$.description || "N/A",
    },
    {
      title: "Date updated",
      value: account.$.dateReported
        ? moment(account.$.dateReported).format("MM/DD/YYYY")
        : "N/A",
    },
    {
      title: "Pay Status",
      value: account.PayStatus?.at(0)?.$.description || "N/A",
    },
    {
      title: "Terms",
      value: `Paid ${getAccountTerms(account)}`,
    },
    {
      title: "Date Closed",
      value: account.$.dateClosed
        ? moment(account.$.dateClosed).format("MM/DD/YYYY")
        : "N/A",
    },
    {
      title: "High Balance",
      value: account.$.highBalance ? `$${account.$.highBalance}` : "N/A",
    },
    {
      title: "Credit Limit",
      value: account.GrantedTrade[0]?.CreditLimit[0]
        ? `$${account.GrantedTrade[0]?.CreditLimit[0]}`
        : "N/A",
    },
    {
      title: "Remarks",
      value: account.Remark?.at(0)?.RemarkCode?.at(0)?.$.description || "N/A",
    },
  ];
};
